import { Component, Input, Output, EventEmitter } from '@angular/core';
import { AuthProvider } from '../../providers/auth/auth';
import { Message, User, HousingUnit } from '../../models/models';
import { ActionSheetController, AlertController, ToastController, ModalController, NavController } from 'ionic-angular';
import { MessageProvider } from '../../providers/message/message';
import { MessageModalPage } from '../../pages/message-modal/message-modal';
import { MessageShowPage } from '../../pages/message-show/message-show';
import { LoginPage } from '../../pages/login/login';
import { MessageCreatePage } from '../../pages/message-create/message-create';
import { UserShowPage } from '../../pages/user-show/user-show';
import { HousingUnitShowPage } from '../../pages/housing-unit-show/housing-unit-show';
//import { MessageCreatePage } from '../../pages/message-create/message-create';


@Component({
	selector: 'message-item',
	templateUrl: 'message-item.html'
})
export class MessageItemComponent {
	@Input() public message: Message;
	@Input() public size: number = 3;

	/**
	Se false il click non produce apertura messaggio
	*/
	@Input() public isClickable: boolean = true;

	@Input() public isDatetimeVisible: boolean = true;

	@Input() public isDeviceVisible: boolean = true;

	private _isMenuVisible: boolean = true;
	/**
	Se false il menù interattivo non è visibile
	*/
	@Input() public set isMenuVisible(isMenuVisible: boolean) {
		//console.debug('[MessageItemComponent.isMenuVisible set] isMenuVisible=' + isMenuVisible)
		this._isMenuVisible = isMenuVisible;
	}
	public get isMenuVisible(): boolean {
		return this._isMenuVisible;
	}
	/**
	Flag per visualizzare il mittente
	*/
	@Input() public isSenderVisible: boolean = true;
	/*
	Se false non può aprire il messaggio anche se ha i permessi
	*/
	@Input() public isShowable: boolean = true;
	/**
	Se false non visualizza la riga con i dati del condominio
	*/
	@Input() public isReceiverVisible: boolean = true;
	/**
	Se non impostato o null usa le logiche di auth, altrimenti forza il risultato del controllo di visualizzabilità
	*/
	@Output() public refresh: EventEmitter<Message> = new EventEmitter<Message>();

	public get isSender(): boolean {
		return this.auth.user && this.auth.user.id == this.message.sender_id;
	}

	public get isReceiver(): boolean {
		return this.auth.user && this.auth.user.id == this.message.receiver_id && this.message.receiver_type == "App\\User";
	}

	constructor(
		private actionSheetCtrl: ActionSheetController,
		private alertCtrl: AlertController,
		public auth: AuthProvider,
		private messages: MessageProvider,
		private modalCtrl: ModalController,
		private navCtrl: NavController,
		private toastCtrl: ToastController
	) {

	}

	public goToHousingUnitShow(housingUnit: HousingUnit, event = null) {
		if (event) {
			event.stopPropagation();
		}
		this.navCtrl.push(HousingUnitShowPage, { housingUnit: housingUnit });
	}


	public goToUserShow(user: User, event = null) {
		if (event) {
			event.stopPropagation();
		}
		this.navCtrl.push(UserShowPage, { user: user });
	}

	public onClick() {
		console.debug('[MessageItem.onClick()] Click sul componente messaggio')
		if (this.isShowable) {
			this.showMessage()
		}
	}

	public showMenu(event: any) {
		event.stopPropagation();

		let self = this;
		let buttons = [];


		if (self.message.sender_type == 'App\\User') {
			let sender = <User>self.message.sender;
			if (!sender) {
				console.warn('Mittente non caricato con il messaggio')
			} else if (self.message.sender_id != self.auth.id) {
				buttons.push({
					text: 'Rispondi a ' + sender.name + ' ' + sender.surname,
					icon: 'share-alt',
					handler: () => {
						self.navCtrl.push(MessageCreatePage, {
							message: this.message,
							user: sender
						})
					}
				});
			}
		}

		if (this.message.sender_type == 'App\\User' && this.message.sender_id != this.auth.id && this.message.condominium && this.auth.hasCondominiumRole(this.message.condominium)) {//inviato da utente autenticato su device pubblico: Bacheca, e l'utente attuale ha un ruolo nel condominio
			buttons.push({
				text: 'Rispondi al condominio',
				icon: 'share-alt',
				handler: () => {
					self.navCtrl.push(MessageCreatePage, {
						condominium: this.message.condominium,
						message: this.message
					})
				}
			});
		}

		if (this.isShowable && this.auth.canMessageShow(this.message)) {
			buttons.push({
				text: 'Visualizza',
				icon: 'eye',
				handler: () => {
					self.showMessage();
				}
			});
		}

		if (this.message.sender_id && this.message.receiver_id) {//possono essere archiviati solo messaggi con entrambi i soggetti, altrimenti si eliminano
			if (this.auth.canMessageHide(this.message)) {
				let text;

				switch (this.message.receiver_type) {
					case 'App\\Condominium':
						text = 'Rimuovi da bacheca'
						break;
					default:
						text = 'Archivia'
						break;
				}

				buttons.push({
					text: text,
					role: 'destructive',
					icon: 'eye-off',
					handler: () => {
						self.showHideMessageConfirm();
					}
				});
			}
		}

		if (this.auth.canMessageDelete(this.message)) {
			let text = 'Elimina';
			if (this.message.sender_id) {
				text += ' per il mittente';
				if (this.message.receiver_id) {
					text += ' e il destinatario';
				}
			}


			buttons.push({
				text: text,
				role: 'destructive',
				icon: 'trash',
				handler: () => {
					self.showDestroyMessageConfirm();
				}
			});
		}



		buttons.push({
			text: 'Annulla',
			role: 'cancel',
			icon: 'undo',
			handler: () => { }
		});

		let title = 'Messaggio del ' + this.message.created_at;
		let subtitle = this.message.subject;

		let options = {
			title: title,
			subTitle: subtitle,
			buttons: buttons
		};

		let actionSheet = this.actionSheetCtrl.create(options);
		actionSheet.present();
	}


	private showDestroyMessageConfirm() {
		if (!this.message) {
			console.error("Messaggio non specificato per message-item");
			return;
		}
		let self = this;
		let message = this.message;

		let confirm = this.alertCtrl.create({
			title: "Eliminare il messaggio dal server?",
			message: "Vuoi davvero eliminare il messaggio '" + message.subject + " del " + message.created_at + "?",
			buttons: [
				{
					text: 'Annulla',
					role: 'cancel'
				}, {
					text: 'Elimina per tutti',
					handler: () => {
						self.messages.destroy(message).then((success: boolean) => {
							if (success) {
								let toast = self.toastCtrl.create({
									message: 'Messaggio eliminato',
									position: 'middle',
									duration: 3000,
									cssClass: "light"
								});
								toast.present();
							} else {
								let toast = self.toastCtrl.create({
									message: "Potrebbe essersi verificato un errore eliminando il messaggio",
									position: 'middle',
									duration: 3000,
									cssClass: "danger"
								});
								toast.present();
							}
							self.refresh.emit(message);
						}).catch(error => {
							console.error("Errore cancellando il messaggio", error);
							let toast = self.toastCtrl.create({
								message: "Errore cancellando il messaggio",
								position: 'middle',
								duration: 3000,
								cssClass: "danger"
							});
							toast.present();
							self.refresh.emit(message);
						});
					}
				}
			]
		});
		confirm.present();
	}

	private showHideMessageConfirm() {
		if (!this.message) {
			console.error("Messaggio non specificato per message-item");
			return;
		}
		let self = this;
		let message = this.message;

		let confirm = this.alertCtrl.create({
			title: "Nascondere il messaggio?",
			message: 'Vuoi davvero archiviare il messaggio "' + message.subject + '" del ' + message.created_at + '?',
			buttons: [
				{
					text: 'Annulla',
					role: 'cancel'
				}, {
					text: 'Archivia',
					handler: () => {
						self.messages.hide(message).then((message: Message) => {
							if (message && (message.is_hidden_to_receiver || message.is_hidden_to_sender)) {
								let toast = self.toastCtrl.create({
									message: 'Messaggio archiviato',
									position: 'middle',
									duration: 3000,
									cssClass: "light"
								});
								toast.present();
							} else {
								let toast = self.toastCtrl.create({
									message: "Potrebbe essersi verificato un errore archiviando il messaggio",
									position: 'middle',
									duration: 3000,
									cssClass: "danger"
								});
								toast.present();
							}
							self.refresh.emit(message);
						}).catch(error => {
							console.error("Errore archiviando il messaggio", error);
							let toast = self.toastCtrl.create({
								message: "Errore archiviando il messaggio",
								position: 'middle',
								duration: 3000,
								cssClass: "danger"
							});
							toast.present();
							self.refresh.emit(message);
						});
					}
				}
			]
		});
		confirm.present();
	}

	private showMessage() {
		if (!this.isShowable) {
			return;
		}
		let self = this;
		if (this.auth.canMessageShow(this.message)) {
			let messageModal = this.modalCtrl.create(
				MessageModalPage,
				{
					message: this.message
				}
			);
			messageModal.present();
			//se non è il mittente a leggere lo segna come letto
			if (this.message.sender_id != this.auth.id || this.message.sender_type != 'App\\User') {
				this.messages.read(this.message).then(message => {
					self.message = message;
				});
			}
		} else if (!this.auth.isAuth && this.message.visibility == 'private') {//vediamo se può vederlo
			let self = this;
			console.info('[MessageItem.showMessage()] Login per leggere il messaggio')
			this.navCtrl.push(LoginPage, {
				next: MessageShowPage,
				nextNavParams: { message: this.message },
				nextGuard: (auth: AuthProvider) => {
					console.debug('[MessageItem.showMessage().LoginPage.nextGuard()] Verifico la visibilità del messaggio post autenticazione')
					return auth.canMessageShow(self.message);
				},
				nextPush: true,
				type: 'pin'
			});
		}
	}
}



// WEBPACK FOOTER //
// ./src/components/message-item/message-item.ts